export type VibeType = {
  src: string
  emoji: string
  isPremium: boolean
  background: string
  text: string
}

export const VIBES: { [key: string]: VibeType } = {
  cool: {
    isPremium: false,
    src: 'Smiling+Face+with+Sunglasses',
    emoji: '😎',
    background: '#e0e4ff',
    text: '#2134c3'
  },
  hangout: {
    isPremium: true,
    src: 'Love-You+Gesture',
    emoji: '🤟',
    background: '#d0e4f7',
    text: '#168fb3'
  },
  drink: {
    isPremium: true,
    emoji: '🥃',
    src: 'Tumbler+Glass',
    background: '#e2d2ff',
    text: '#554293'
  },
  like: {
    isPremium: false,
    src: 'Waving+Hand',
    emoji: '👋',
    background: '#ffe4d2',
    text: '#dd5e46'
  },
  flirt: {
    isPremium: true,
    src: 'Sparkling+Heart',
    emoji: '💖',
    background: '#fbc9de',
    text: '#d42a62'
  },
  fun: {
    isPremium: true,
    src: 'Grinning+Squinting+Face',
    emoji: '😆',
    background: '#e7fdf4',
    text: '#22b290'
  },
  common: {
    isPremium: false,
    src: 'Glowing+Star',
    emoji: '⭐',
    background: '#f4dff9',
    text: '#bf3294'
  },
  support: {
    isPremium: true,
    src: 'Sun',
    emoji: '☀️',
    background: '#fbeccf',
    text: '#ef5a3c'
  }
} as const